import { BillingStatus, RateInfo } from '../models';
import { TimeEntryBreakDto } from './shifts/shift-breaks.dto';
import {
  ScopeOfPracticeEnum,
  ShiftTypeEnum,
  ShiftStatusEnum,
  TimeString
} from '@umss/shared/utils';

export interface Shift {
  id: string; // Guid
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
  shiftNeedId: string; // Guid
  facilityId: string;
  facilityName: string;
  facilityFullAddress?: string;
  facilityTimeZone?: string; // IANA id (e.g. "America/Denver") — null/absent when the facility has none
  facilitySubtypeId?: number;
  facilitySubtypeName?: string;
  distanceMiles?: number;
  contractorId: string;
  contractorName: string;
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay?: string;
  shiftType: ShiftTypeEnum;
  shiftTypeDisplay: string;
  shiftDate: string;
  startTime: TimeString;
  endTime: TimeString;
  specialInstructions?: string;
  status: ShiftStatusEnum;
  statusDisplay: string;
  confirmedAt?: string;
  confirmedByName?: string;
  estimatedHours: number;
  estimatedPayment: number;
  rateInfo?: RateInfo;

  // Actual time tracking (from TimeEntry)
  actualStartTime?: string; // ISO datetime when contractor clocked in
  actualEndTime?: string; // ISO datetime when contractor clocked out
  actualHoursWorked?: number; // Decimal hours worked (e.g., 8.25)s
  actualPayment?: number; // Calculated payment based on actual hours

  breaks: TimeEntryBreakDto[];

  isEditable?: boolean;
  timesheetStatus?: BillingStatus;

  // Grace window bounds (UTC) — BE computes these from the facility's timezone.
  // FE compares dayjs() against these to determine if a note is required in real time.
  // Null when EnforceClockWindows is off.
  clockInWindowStart?: string;
  clockInWindowEnd?: string;
  clockOutWindowStart?: string;
  clockOutWindowEnd?: string;

  // Notes written when clocking in/out outside the grace window
  clockInNote?: string;
  clockOutNote?: string;
}
